// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d514dd8c","977":"4664fd6e"}[chunkId] + ".chunk.js";
};